import { render } from "./ObjectTeaserComponent.vue?vue&type=template&id=f2dd222e&ts=true"
import script from "./ObjectTeaserComponent.vue?vue&type=script&lang=ts"
export * from "./ObjectTeaserComponent.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./ObjectTeaserComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__